<template>
  <div>
    <GlobalHeader />
    <div class="categoryHead" :class="{ categoryHeadBottomNon: !this.isWinnerList() }"><!-- categoryHeadBottomNonはサブメニューがない時に適用するクラス -->
      <div class="inner">
        <nav class="categoryHeadArea">
          <ul class="specials">
            <li><router-link to="/artworks/Tcc10Sen" :class="{ location: isSelected('/artworks/Tcc10Sen') }">東京カメラ部10選</router-link></li>
            <li><router-link to="/artworks/Japan100Views" :class="{ location: isSelected('/artworks/Japan100Views') }">日本写真100景</router-link></li>
            <li><router-link to="/artworks/MyPrecious" :class="{ location: isSelected('/artworks/MyPrecious') }">"My Precious" Photo Contest</router-link></li>
            <li><router-link to="/exhibitors" :class="{ location: isSelected('/exhibitors') }">展示者一覧</router-link></li>
          </ul>
        </nav>
      </div><!-- /inner-->
    </div><!-- /categoryHead-->
    <HeaderSub v-if="!this.isWinnerList()" />
  </div>
</template>

<script>
import GlobalHeader from './GlobalHeader'
import HeaderSub from './HeaderSub'

export default {
  components: {
    GlobalHeader,
    HeaderSub
  },
  methods: {
    isSelected (str) {
      return this.$route.path.indexOf(str) >= 0
    },
    isWinnerList () {
      return (this.$route.path === '/exhibitors')
    }
  }
}
</script>
